import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import createHistory from 'history/createBrowserHistory'
import {routerMiddleware} from 'react-router-redux'
import {googleAnalytics} from "../utils/reactGAMiddlewares";

export const history = createHistory();
history.listen(() => window.scrollTo(0, 0))
const reactRouterMiddleware = routerMiddleware(history);
const middlewares = [
    // Add other middleware on this line...

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    thunk,
    reactRouterMiddleware,
    googleAnalytics,
];

export default function configureStore(initialState) {

    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(...middlewares)
    );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js